import angular from 'angular';

angular.module('app.ctrls')
    .controller('UserCommentsModalController', ['$scope', '$modalInstance', 'message', function($scope, $modalInstance, message){

            $scope.message = message;
            $scope.userObj = {};
            $scope.ok = function () {
            	console.log($scope.userObj);
                $modalInstance.close($scope.userObj);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

        }]);